<template>
  <RCard class="licenses">
    <FormLicensePeriod
      :showing="showModal"
      :license-period="licensePeriod"
      :disable-properties="['publisher_id']"
      @refresh="refresh"
      @close="showModal = false"
    />

    <AgGrid ref="wrapper" :options="gridOptions" :row-data="licenses">
      <template #header>
        <Grid gaf="column" align-items="center" justify-content="space-between">
          <div class="text-subtitle-1 text-secondary-2">Licenses</div>

          <RBtn size="small" type="text" @click="showModal = true">
            <div class="text-overline-1 text-secondary-1">Create new license</div>
          </RBtn>
        </Grid>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import gridOptions from './gridOptions'
// Libraries
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import FormLicensePeriod from '@components/forms/form-license-period/FormLicensePeriod'

export default {
  components: {
    AgGrid,
    FormLicensePeriod
  },

  mixins: [gridOptions],

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    licenses: null,
    showModal: false
  }),

  computed: {
    ...mapState('publisher-show', ['publisher']),

    licensePeriod() {
      return {
        previous_license_period_id: null,
        license_id: null,
        publisher_id: this.publisher.id,
        name: null,
        start_date: Date.now(),
        end_date: null,
        summary: null,
        subscriptions: [],
        owner_id: null,
        license_file: null,
        terms: []
      }
    }
  },

  async created() {
    await this.$store.dispatch('licensePeriods/getCreateFormData')
    this.getLicenses()
  },

  methods: {
    getLicenses() {
      apiTo.GET_PUBLISHER_LICENSES(this.id).then(({ data }) => this.setLicensePeriodId(data.result))
    },

    setLicensePeriodId(originalLicenses) {
      const licenses = cloneDeep(originalLicenses)

      this.licenses = licenses.reduce((acc, curr) => {
        curr.periods.forEach(period => (period.license_id = curr.id))
        acc.push(...curr.periods)
        return acc
      }, [])
    },

    refresh() {
      this.showModal = false
      this.getLicenses()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.licenses {
  @include table-with-no-filters;
}
</style>
